import styled from 'styled-components';
import { NAV_SIDEBAR_WIDTH } from '@components/navSidebar/NavSidebar.styles';
import { device } from '@styles/tools/breakpoints.styles';

export const Container = styled.div`
  display: flex;
  flex: 1;
`;

export const StyledMain = styled.main`
  display: flex;
  margin-left: 0;
  width: 100%;
  flex-direction: column;

  ${device.desktopLarge} {
    padding-right: ${NAV_SIDEBAR_WIDTH}px;
  }

  ${device.desktop} {
    margin-left: ${NAV_SIDEBAR_WIDTH}px;
  }
`;
